export default __webpack_public_path__ + "static/media/poison.f6fda774.svg";